import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e26535e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "user-profile" }
const _hoisted_2 = { class: "box" }

import { toRefs } from 'vue'

  import UserHeader from '@/components/User/ProfileDisplay/UserHeader.vue'
  import UserProfileTabs from '@/components/User/UserProfileTabs.vue'
  import { IUserProfile } from '@/types/user'

  interface Props {
    user: IUserProfile
    tab: string
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    user: null,
    tab: null
  },
  setup(__props: any) {

const props = __props as {
    user: IUserProfile
    tab: string
  }

  

  const { user, tab } = toRefs(props)
  const tabs = ['PROFILE', 'PREFERENCES', 'SPORTS']

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UserHeader, { user: _unref(user) }, null, 8, ["user"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(UserProfileTabs, {
        tabs: tabs,
        selectedTab: _unref(tab),
        edition: false
      }, null, 8, ["selectedTab"]),
      _createVNode(_component_router_view, { user: _unref(user) }, null, 8, ["user"])
    ])
  ]))
}
}

})